export default function (state, action) {
  switch (action.type) {
    case 'SET_USER':
      return {
        ...state,
        ...action.data,
      };
    default:
      return state;
  }
}
